import api from 'api';

const unwrap = (res) => res.data.data;

export const bankRaw = async (alertId) =>
    unwrap(await api.post('/raw-banks', { alertId }));

export const fetchMyBanks = async () =>
    unwrap(await api.get('/raw-banks/mine'));

// Every Raw the journalist has banked: each can be banked only once.
export const fetchMyBankHistory = async () =>
    unwrap(await api.get('/raw-banks/mine/history'));

export const fetchBankStatus = async (alertId) =>
    unwrap(await api.get(`/raw-banks/alerts/${alertId}`));

export const fetchLiveBanks = async () => unwrap(await api.get('/raw-banks'));

export const fetchBankStats = async () =>
    unwrap(await api.get('/raw-banks/stats'));

export const unbankRaw = async (id) =>
    (await api.post(`/raw-banks/${id}/unbank`)).data;

export const releaseBank = async (id) =>
    (await api.post(`/raw-banks/${id}/release`)).data;
